export default __webpack_public_path__ + "static/media/safety-card-front.2660d973.svg";